import { render, staticRenderFns } from "./planB.vue?vue&type=template&id=46d3211c"
import script from "./planB.vue?vue&type=script&lang=js"
export * from "./planB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports